import _remove from 'lodash/remove';
import addStudentTemplate from './../../settings/add-student/add-student.html';
import template from './edit-happening.html';

class EditHappeningComponent {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, $state, moment,
    HappeningService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$state = $state;
    this.moment = moment;
    this.HappeningService = HappeningService;

    this.selectedStudents = [];
    this.selectedStudentsIDs = [];
    this.disableAddStudent = false;
  }

  $onInit() {
    this.date = this.moment(this.happening.date).toDate();
    this.selectedStudents = this.happening.students;
    this.selectedStudents.forEach(student => {
      this.selectedStudentsIDs.push(Number(student.id));
    });
  }

  $onChanges(changes) {
    if (changes.happening) {
      this.happening = {...this.happening};
    }
  }

  addStudent(ev) {
    this.$mdDialog.show({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'AddHappeningStudentController',
      template: addStudentTemplate,
      clickOutsideToClose: true,
      locals: {happeningId: this.happening.id},
      targetEvent: ev
    })
      .then(result => {
        _remove(this.selectedStudents, student => student.id === result.id);
        this.selectedStudents.unshift(result);
        this.selectedStudentsIDs.push(Number(result.id));
      }, () => {});
  }

  removeStudent(studentToRemove) {
    this.disableAddStudent = true;
    _remove(this.selectedStudents, student => student.id === studentToRemove.id);
    _remove(this.selectedStudentsIDs, id => id === Number(studentToRemove.id));
    this.happening.date = this.moment(this.date).format('YYYY-MM-DD');
    this.happening.students = this.selectedStudentsIDs;
    this.happening.studentObjects = this.selectedStudents;
    this.HappeningService.edit({data: this.happening})
      .then(() => {
        this.disableAddStudent = false;
      })
      .catch(() => {
        this.disableAddStudent = false;
      });
  }

  edit(form) {
    if (form.$invalid) {
      return false;
    }

    this.happening.date = this.moment(this.date).format('YYYY-MM-DD');
    this.happening.students = this.selectedStudentsIDs;
    this.happening.studentObjects = this.selectedStudents;

    this.HappeningService.edit(
      {
        data: this.happening
      }
    ).then(() => {
      this.$state.go('modules.happenings');
      this.$mdToast.show(
        this.$mdToast.simple()
          .textContent('Edytowano wydarzenie')
          .position('bottom right')
          .hideDelay(3000)
      );
    })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }
}

export const EditHappening = {
  bindings: {
    happening: '<'
  },
  template,
  controller: EditHappeningComponent
};
